module.exports = {
    en: {
        carditem: {
            details: 'View Details',
            write: 'Write to us',
            box1txt: "test",
            box2txt: "test",
            contact: "Send request",
        }
    },
    ka: {
        carditem: {
           details: 'დეტალების ნახვა',
            write: 'მოგვწერეთ',
            box1txt: "სატესტო",
            box2txt: "სატესტო",
            contact: "მოთხოვნის გაგზავნა",
        }
    },
    ru: {
        carditem: {
            details: 'Посмотреть детали',
            write: 'Напишите нам',
            box1txt: "тест",
            box2txt: "тест",
            contact: "Отправить запрос",
        }
    }
}